import React from "react";
import { css } from "@emotion/react";

export interface ISelectOption {
  label: string;
  value?: any;
}
export interface IToolbarSelecProps
  extends React.HTMLAttributes<HTMLSelectElement> {
  prefix?: string;
  label?: string;
  onChange?: (value: any) => void;
  value?: any;
  inline?: boolean;
  options?: ISelectOption[];
}

export const ToolbarSelect = ({
  onChange,
  value,
  prefix,
  label,
  inline,
  options = [],
  ...rest
}: IToolbarSelecProps) => {
  return (
    <div>
      <select
        onChange={(e) => {
          onChange?.(e.target.value);
        }}
        value={value}
        css={css`
          color: var(--builder-text-color);
          border: none;
          padding: 0 4px 0 8px;
          border-right: 10px solid var(--builder-textbox-background);
          font-size: 13px;
          //-webkit-appearance: none;
          background: var(--builder-textbox-background) no-repeat right center;
          box-shadow: var(--builder-input-box-shadow);

          width: 100%;
          min-height: 25px;
          border-radius: 3px;
          padding-right: 15px;

          outline: none;
          position: relative;
          font-family: sans-serif;

          option {
            background: var(--builder-textbox-background) no-repeat right center;
          }
        `}
        {...rest}
      >
        {options.map((item, index) => (
          <option
            key={index}
            value={item.value}
            css={css`
              font-size: 13px;
              outline: none;
            `}
          >
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};
